export const TABLE_NAME = {
  ABSENCES: 'absences',
  BALANCE_CHANGES: 'balanceChanges',
  BALANCES: 'balances',
  TIMEOFFS: 'timeoffs',
  USERS: 'users'
}

export const EMPLOYMENT = {
  FT: {
    type: 'FT',
    fullForm: 'Full Time'
  },
  PT: {
    type: 'PT',
    fullForm: 'Part Time'
  }
}

export const TIMEOFF = {
  PTO: {
    type: 'pto',
    fullForm: 'Paid Time Off'
  },
  PSL: {
    type: 'psl',
    fullForm: 'Paid Sick Leave'
  },
  HPSL: {
    type: 'hpsl',
    fullForm: 'Half-Pay Sick Leave'
  },
  UPTO: {
    type: 'upto',
    fullForm: 'Unpaid Time Off'
  },
  UPSL: {
    type: 'upsl',
    fullForm: 'Unpaid Sick Leave'
  },
  SPEC: {
    type: 'spec',
    fullForm: 'Special Leave'
  },
  WFH: {
    type: 'wfh',
    fullForm: 'Work From Home'
  }
}

export const TIMEOFF_STATUS = {
  PENDING: 'pending',
  REJECTED: 'rejected',
  CANCELLED: 'cancelled',
  APPROVED: 'approved'
}

export const absenceDisplays = {
  t: 'Tardiness',
  et: 'Extreme Tardiness',
  awol: 'Absence Without Official Leave'
};

// for list of 2 chars country codes, please refer to ISO 3166
export const COUNTRY = {
  TW: {
    code: 'TW',
    name: 'Taiwan'
  },
  HK: {
    code: 'HK',
    name: 'Hong Kong'
  },
  US: {
    code: 'US',
    name: 'United States'
  }
}



// WEBPACK FOOTER //
// ./src/helpers/constants.js